import {
  IonButton,
  IonCard, IonCardHeader, IonCardTitle, IonCol, IonGrid, IonInput, IonItem, IonLabel, IonList, IonRow, IonSpinner, IonText
} from '@ionic/react';
import React, { useContext, useState } from 'react';
import ServerDBContext from '../ServerDBContext/ServerDBContext';
import './ResetPassword.scss';

interface IResetPasswordProps {
  email?: string
}

const ResetPassword: React.FC<IResetPasswordProps> = (props) => {
  const [email, setEmail] = useState(props.email ? props.email : '');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [usernameError, setUsernameError] = useState(false);
  const [loginMessage, setLoginMessage] = useState('');
  const dbService = useContext(ServerDBContext);

  const login = (e: React.FormEvent) => {
    e.preventDefault();
    setFormSubmitted(true);
    if(!email) {
      setUsernameError(true);
    } else {
      setUsernameError(false);
    }

    if(email) {
      setLoginMessage('Sending Reset Password Email');
      dbService?.resetPassword(email).then(result => {
        if(result.Success) {
          setEmail('');
          setLoginMessage(`${result.Message.UserMessage}. NOTE: please check your SPAM folder if you can't find the email.`);
        } else {
          setLoginMessage(result.Message.UserMessage);
        }
      })
    }
  };

  return (
    <IonCard>
      <IonCardHeader color="tertiary" ><IonCardTitle className="ion-text-center">RESET YOUR PASSWORD</IonCardTitle></IonCardHeader>
      <form noValidate onSubmit={login}>
          <IonList className="login-card-fields-list">
            <IonItem>
              <IonLabel className="form-label" position="floating">Your Email</IonLabel>
              <IonInput name="username" type="text" value={email} spellCheck={false} autocapitalize="off" onIonChange={e => setEmail(e.detail.value?.toString()!)}
                required>
              </IonInput>
            </IonItem>

            {formSubmitted && usernameError && <IonText color="danger">
              <p className="ion-padding-start">
                Your Email is required
              </p>
            </IonText>}
          </IonList>
          <IonGrid>
           <IonRow>
            <IonCol>
              <IonButton disabled={loginMessage === 'Sending Reset Password Email'} color="tertiary" type="submit" expand="block">Reset Password</IonButton>
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol>
              {
                loginMessage === 'Sending Reset Password Email' ? 
                  <IonText className="login-message" color="primary">
                    <IonSpinner name="dots" color="primary"/><br />
                    {loginMessage}
                  </IonText> : 
                  <IonText className="login-message" color="danger">
                    {loginMessage}
                  </IonText>
              }
            </IonCol>
          </IonRow>
          </IonGrid>
        </form>
    </IonCard>
  );
};

export default ResetPassword;